import firebaseService from './FirebaseService';

interface Course {
  id: string;
  name: string;
  lectureCount: number;
  watchedLectures: number;
  createdAt: string;
  lastAccessed: string;
}

class StorageService {
  async getItem<T>(key: string, defaultValue: T | null = null): Promise<T | null> {
    try {
      return await firebaseService.getItem(key, defaultValue);
    } catch (error) {
      console.error(`Error reading ${key} from Firebase:`, error);
      return defaultValue;
    }
  }

  async setItem(key: string, value: any): Promise<boolean> {
    try {
      return await firebaseService.setItem(key, value);
    } catch (error) {
      console.error(`Error saving ${key} to Firebase:`, error);
      return false;
    }
  }

  async removeItem(key: string): Promise<boolean> {
    try {
      return await firebaseService.removeItem(key);
    } catch (error) {
      console.error(`Error removing ${key} from Firebase:`, error);
      return false;
    }
  }

  async getCourses(): Promise<Course[]> {
    try {
      return await firebaseService.getCourses();
    } catch (error) {
      console.error('Error getting courses from Firebase:', error);
      return [];
    }
  }

  async setCourses(courses: Course[]): Promise<boolean> {
    try {
      return await firebaseService.setCourses(courses);
    } catch (error) {
      console.error('Error setting courses in Firebase:', error);
      return false;
    }
  }
}

const storageService = new StorageService();
export default storageService; 